import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Box, Button, IconButton, Select, MenuItem, Grid } from '@material-ui/core';
import { Add as AddIcon, ArrowForward as DetailIcon } from '@material-ui/icons';
import MaterialTable from 'material-table';
import { fetchProvvigioni } from '../../../redux/actions/Provvigioni';
import { fetchAgenti } from '../../../redux/actions/Agenti';
import moment from 'moment';

const Provvigioni = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { provvigioni, loading } = useSelector(state => state.provvigioni);
  const { agenti } = useSelector(state => state.agenti);
  const [filteredProvvigioni, setFilteredProvvigioni] = useState([]);
  const [selectedStato, setSelectedStato] = useState('all');

  useEffect(() => {
    dispatch(fetchProvvigioni());
    dispatch(fetchAgenti());
  }, [dispatch]);

  // Sync filtered data when provvigioni changes
  useEffect(() => {
    if (selectedStato === 'all' || selectedStato === '5') {
      // 'all' shows all active; '5' shows all archived (already filtered by API)
      setFilteredProvvigioni(provvigioni);
    } else {
      setFilteredProvvigioni(provvigioni.filter(p => String(p.stato_new || '0') === selectedStato));
    }
  }, [provvigioni, selectedStato]);

  const handleStatoChange = event => {
    const value = event.target.value;
    setSelectedStato(value);

    if (value === '5') {
      // Fetch archived provvigioni from backend
      dispatch(fetchProvvigioni(1));
    } else {
      // Fetch active provvigioni
      dispatch(fetchProvvigioni(0));
    }
  };

  const handleNewProvvigione = () => {
    history.push('/provvigione/new');
  };

  const handleDetail = id => {
    history.push(`/provvigione/${id}`);
  };

  const formatCurrency = value => {
    if (!value) return '€ 0,00';
    return new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: 'EUR',
    }).format(value);
  };

  const columns = [
    {
      title: 'Data creazione',
      field: 'data_creazione',
      render: rowData => moment(rowData.data_creazione).format('DD/MM/YYYY'),
    },
    {
      title: 'N. Prov.',
      field: 'numero',
    },
    {
      title: 'Fornitore',
      field: 'fornitore',
    },
    {
      title: 'Cliente',
      field: 'cliente',
    },
    {
      title: 'Descrizione',
      field: 'descrizione',
      render: rowData => {
        const desc = rowData.descrizione || '';
        return desc.length > 50 ? desc.substring(0, 50) + '...' : desc;
      },
    },
    {
      title: 'Tot. offerta',
      field: 'totale_offerta',
      render: rowData => formatCurrency(rowData.totale_offerta),
    },
    {
      title: 'Stato',
      field: 'stato_new',
      render: rowData => {
        const statoMap = {
          '0': 'Attiva',
          '1': 'In contatto',
          '2': 'In corso/C.O.',
          '3': 'Provvigione/FT',
          '4': 'Rifiutata',
          '5': 'Archiviata',
        };
        return statoMap[rowData.stato_new] || 'Attiva';
      },
    },
    {
      title: 'Agente',
      field: 'agente_nome',
    },
    {
      title: '%',
      field: 'percentuale',
      render: rowData => `${rowData.percentuale}%`,
    },
    {
      title: 'Tot. Provv.',
      field: 'totale_provvigione',
      render: rowData => formatCurrency(rowData.totale_provvigione),
    },
    {
      title: 'Dettaglio',
      render: rowData => (
        <IconButton size="small" onClick={() => handleDetail(rowData.id)}>
          <DetailIcon />
        </IconButton>
      ),
    },
  ];

  return (
    <Box p={3}>
      <Box mb={2} display="flex" justifyContent="space-between" alignItems="center">
        <Box display="flex" alignItems="center">
          <label style={{ marginRight: 10 }}>Filtra per stato: </label>
          <Select style={{ minWidth: 200 }} value={selectedStato} onChange={handleStatoChange} displayEmpty>
            <MenuItem value="all">Tutte</MenuItem>
            <MenuItem value="0">Attiva</MenuItem>
            <MenuItem value="1">In contatto</MenuItem>
            <MenuItem value="2">In corso/C.O.</MenuItem>
            <MenuItem value="3">Provvigione/FT</MenuItem>
            <MenuItem value="4">Rifiutata</MenuItem>
            <MenuItem value="5">Archiviata</MenuItem>
          </Select>
        </Box>
        <Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={handleNewProvvigione}>
          Nuova Provvigione
        </Button>
      </Box>

      <MaterialTable
        title="Provvigioni"
        columns={columns}
        data={filteredProvvigioni}
        isLoading={loading}
        options={{
          search: true,
          sorting: true,
          pageSize: 10,
          pageSizeOptions: [10, 20, 50, 100],
          filtering: false,
          searchFieldAlignment: 'right',
          searchFieldStyle: {
            width: '300px',
          },
        }}
        localization={{
          pagination: {
            labelDisplayedRows: '{from}-{to} di {count}',
            labelRowsSelect: 'righe',
          },
          toolbar: {
            searchPlaceholder: 'Cerca',
            nRowsSelected: '{0} selezionate',
          },
          header: {
            actions: 'Azioni',
          },
          body: {
            editRow: {
              deleteText: 'Sei sicuro di voler eliminare questa provvigione?',
            },
            emptyDataSourceMessage: 'Non ci sono provvigioni',
            filterRow: {
              filterTooltip: 'Filtro',
            },
          },
        }}
      />
    </Box>
  );
};

export default Provvigioni;
